import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  tab(e) {
    const element = e.currentTarget
    const id = element.getAttribute('data-id')

    if (element.classList.contains('catalog-list__item-active')) {
      element.classList.remove('catalog-list__item-active')
      document.querySelectorAll('.catalog-blocks .item').forEach(i => i.classList.add('item-active'))
      history.pushState('', document.title, '/');
    } else {
      document.querySelectorAll('.catalog-list__item-active').forEach(i => i.classList.remove('catalog-list__item-active'))
      element.classList.add('catalog-list__item-active')
      document.querySelectorAll('.catalog-blocks .item').forEach(i => i.classList.remove('item-active'))
      document.querySelectorAll(`.catalog-blocks .item[data-category-id="${id}"]`).forEach(i => i.classList.add('item-active'))
      history.pushState('', document.title, `#${id}`);
    }
  }

  product(e) {
    const element = e.currentTarget
    const id = element.getAttribute('data-id')
    const product = products.find(p => p.id === id)

    const popup = document.querySelector('.popup_product')
    const popupProductId = document.querySelector('input[name="product_id"]')
    const popupName = document.querySelector('.product__name')
    const popupDescription = document.querySelector('.product__description')
    const popupPrice = document.querySelector('.product__price')
    const popupImages = document.querySelector('.product-images')

    popupProductId.value = product.id
    popupName.innerText = product.name
    popupDescription.innerText = product.description
    popupImages.innerHTML = product.assets.map((asset, index) => `<img data-index=${index} data-action="click->popup#gallery" src=${asset.image.url} />`).join('')

    popupPrice.innerHTML = element.querySelector('.item__price').innerHTML
    if (product.assets.length === 0) {
      popupImages.innerHTML = element.querySelector('.item__image_default').outerHTML
    }

    history.pushState('', document.title, `#${product.id}`);

    popup.classList.add('popup_visible')
  }

}